// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3yof1","ranges":"BmiRanges_ranges__ZVpeg"};